import * as Schema from "effect/Schema";

/**
 * CardWidget — a themed content surface backed by Duro's `<Card>` (title via the
 * card header, body as Duro `<Text>`). `variant`/`size` map onto Duro's card API.
 */
export const CardWidgetContent = Schema.Struct({
  contentType: Schema.Literal("card"),
  title: Schema.optional(Schema.String),
  body: Schema.optional(Schema.String),
  variant: Schema.optional(
    Schema.Literal("elevated", "outlined", "filled", "interactive"),
  ),
  size: Schema.optional(Schema.Literal("default", "compact", "full")),
});
export type CardWidgetContent = Schema.Schema.Type<typeof CardWidgetContent>;
